import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'join',
    standalone: false
})
export class JoinPipe<T>implements PipeTransform {

    /**
     * Applique la fonction join sur un tableau
     * @param arrayToJoin tableau ou tablobjet a transformer en string
     * @param separator élément de séparation entre les éléments de arrayToJoin ', ' par défaut
     * @param toString fonction a appliquer sur les éléments avant le join
     */
    transform(arrayToJoin: {[key: string]: T[]} | T[], separator: string = ', ', toString?: (object: T) => string): string {
        // Si arrayToJoin est null on retourne une chaine vide
        if (!arrayToJoin) {
            return '';
        }

        // Si arrayToJoin est un objet de type ArrayOfQuelqueChose { string: [...] }
        // on extrait le tableau à l'aide de la 1ère clé de l'objet
        const array = Array.isArray(arrayToJoin) ? arrayToJoin : arrayToJoin[Object.keys(arrayToJoin)[0]];

        // Si une fonction toString est fournie on l'applique à chaque élément du tableau avant le join
        if (toString && typeof toString === 'function') {
            return array.map(toString).join(separator);
        }

        // array.join
        return array.join(separator);
    }

}
